import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const AdminRegister = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const register = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${config.API_BASE_URL}${config.ADMIN.REGISTER}`, {
        email,
        password
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("adminID", res.data.adminID);
      navigate(res.data?.redirectTo || "/admin/profile-setup");
    } catch (err) {
      setError(err.response?.data?.error || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <div style={container}>
        <form style={card} onSubmit={register}>
          <h1 style={title}>Kin-Keeper Registration</h1>

          <input
            style={input}
            type="email"
            placeholder="Email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <div style={passwordWrapper}>
            <input
              style={{ ...input, paddingRight: "42px" }}
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              required
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span onClick={() => setShowPassword(!showPassword)} style={eyeIcon}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div style={passwordWrapper}>
            <input
              style={{ ...input, paddingRight: "42px" }}
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm Password"
              required
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <span onClick={() => setShowConfirmPassword(!showConfirmPassword)} style={eyeIcon}>
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {error ? <p style={errorText}>{error}</p> : null}

          <button style={button} disabled={loading}>
            {loading ? "Registering..." : "Register Kin-Keeper"}
          </button>

          <p style={footerText}>
            Already have an account?{" "}
            <Link to="/admin/login" style={linkStyle}>
              Login
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default AdminRegister;

const page = {
  minHeight: "calc(100vh - 112px)",
  background: "#f4f9fd",
  padding: "40px 20px"
};

const container = {
  maxWidth: "500px",
  margin: "0 auto",
  padding: "40px"
};

const card = {
  background: "white",
  borderRadius: "16px",
  padding: "32px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
  border: "1px solid #e2e8f0",
  display: "grid",
  gap: "12px"
};

const title = {
  margin: "0 0 10px 0",
  color: "#0E5580",
  fontSize: "2rem",
  textAlign: "center"
};

const input = {
  width: "100%",
  padding: "16px 18px",
  borderRadius: "10px",
  border: "1px solid #cddde9",
  background: "#f9fbfd",
  boxSizing: "border-box",
  fontSize: "18px",
  color: "#12344d",
  marginBottom: "4px"
};

const passwordWrapper = {
  position: "relative",
  display: "flex",
  alignItems: "center"
};

const eyeIcon = {
  position: "absolute",
  right: "16px",
  cursor: "pointer",
  color: "#6b8396",
  fontSize: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%"
};

const button = {
  background: "#0E5580",
  color: "white",
  minHeight: "52px",
  padding: "14px 16px",
  borderRadius: "10px",
  fontWeight: "600",
  border: "none",
  cursor: "pointer",
  fontSize: "18px"
};

const footerText = {
  margin: "6px 0 0 0",
  textAlign: "center",
  color: "#475569"
};

const linkStyle = {
  color: "#0E5580",
  fontWeight: "600",
  textDecoration: "none"
};

const errorText = {
  margin: "0",
  color: "#b91c1c",
  fontSize: "14px"
};
